define([
    'santa-components',
    'lodash',
    'coreUtils',
    'socialCommon',
    'components',
    'skins',
    'wTwitterTweet/skins/skins.json',
    'componentsCore'
], function (
    santaComponents,
    _,
    coreUtils,
    socialCommon,
    components,
    skinsPackage,
    skinsJson,
    componentsCore
) {
    'use strict';

    const urlUtils = coreUtils.urlUtils;

    /**
     * @class components.WTwitterTweet
     * @extends {core.skinBasedComp}
     */
    const wTwitterTweet = {
        displayName: 'WTwitterTweet',
        propTypes: {
            id: santaComponents.santaTypesDefinitions.Component.id.isRequired,
            rootId: santaComponents.santaTypesDefinitions.Component.rootId,
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            isMobileView: santaComponents.santaTypesDefinitions.isMobileView,
            santaBase: santaComponents.santaTypesDefinitions.santaBase.isRequired,
            origin: santaComponents.santaTypesDefinitions.Location.origin
        },
        static: {
            useSantaTypes: true
        },
        mixins: [componentsCore.mixins.skinBasedComp, socialCommon.twitterComponentMixin, socialCommon.socialCompMixin],
        getIFrameSrc() {
            const urlParams = {
                href: 'https://twitter.com/share',
                lang: this.getLanguage(),
                url: this.getSocialUrl(this.props.rootId === 'masterPage'),
                text: this.props.compData.defaultText,
                related: this.props.compData.accountToFollow,
                compId: this.props.id,
                origin: this.props.origin,
                widgetType: 'TWEET'
            };

            if (this.props.isMobileView) {
                urlParams.size = 'l';
            }

            return `${this.props.santaBase}/static/external/twitter.html?${urlUtils.toQueryString(urlParams)}`;
        },

        getIframeTitleName() {
            return 'component_label_ twitterTweetTitle';
        }
    };

    componentsCore.compRegistrar.register('wysiwyg.viewer.components.WTwitterTweet', wTwitterTweet);
    components.translationRequirementsChecker.registerCommonLanguageRequirement(
        'wysiwyg.viewer.components.WTwitterTweet',
        (siteData, compInfo) => _.get(compInfo, ['properties', 'dataLang']));
    skinsPackage.skinsMap.addBatch(skinsJson);

    return wTwitterTweet;
});
